export default "__VITE_ASSET__8e43f86f__"